import React from 'react';
import { FaArrowUp, FaArrowDown } from 'react-icons/fa';
import '../styles/DentalArch.css';

const DentalArch = ({ selectedTeeth, onToothSelect, teethConfig, onArcadeSelect }) => {
  // Define teeth numbers for upper and lower arches
  const upperTeeth = [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28];
  const lowerTeeth = [48, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38];

  // Helper function to determine tooth class
  const getToothClass = (toothId) => {
    let classes = 'tooth';
    if (selectedTeeth.includes(toothId)) {
      classes += ' selected';
    }

    // Check if tooth is configured (works for both object and array formats)
    const isConfigured = Array.isArray(teethConfig)
      ? teethConfig.some(line => line.teeth && line.teeth.map(t => t.toString()).includes(toothId.toString()))
      : teethConfig[toothId];

    if (isConfigured) {
      classes += ' configured';
    }
    return classes;
  };

  const isArcadeSelected = (arcadeId) => selectedTeeth.includes(arcadeId);
  const isArcadeConfigured = (arcadeId) => Array.isArray(teethConfig)
    ? teethConfig.some(line => line.teeth && line.teeth.includes(arcadeId))
    : false;

  const getArcadeBtnClass = (arcadeId) => {
    let cls = 'arcade-select-btn';
    if (isArcadeSelected(arcadeId)) cls += ' selected';
    if (isArcadeConfigured(arcadeId)) cls += ' configured';
    return cls;
  };

  const handleArcadeClick = (arcadeId) => {
    if (onArcadeSelect) {
      onArcadeSelect(arcadeId);
    }
  };

  return (
    <div className="dental-arch-container">
      {/* Arcade Buttons */}
      <div className="arcade-buttons-row">
        <button
          className={getArcadeBtnClass('HAUT')}
          onClick={() => handleArcadeClick('HAUT')}
          title="Sélectionner l'arcade supérieure (Haut) – pour modèle, PEI, châssis, etc."
        >
          <FaArrowUp className="arcade-btn-icon" />
          <span>Arcade Haut</span>
        </button>
        <button
          className={getArcadeBtnClass('BAS')}
          onClick={() => handleArcadeClick('BAS')}
          title="Sélectionner l'arcade inférieure (Bas) – pour modèle, PEI, châssis, etc."
        >
          <FaArrowDown className="arcade-btn-icon" />
          <span>Arcade Bas</span>
        </button>
      </div>

      <div className="arch-label">Arcade Supérieure</div>
      <div className="upper-arch">
        {upperTeeth.map((toothId) => (
          <div
            key={toothId}
            className={getToothClass(toothId)}
            onClick={() => onToothSelect(toothId)}
          >
            <div className="tooth-number">{toothId}</div>
          </div>
        ))}
      </div>

      <div className="arch-diagram">
        <svg viewBox="0 0 400 200" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M 50,50 C 100,20 300,20 350,50 C 370,100 350,150 200,180 C 50,150 30,100 50,50 Z"
            fill="none"
            stroke="#ccc"
            strokeWidth="2"
          />
        </svg>
      </div>

      <div className="lower-arch">
        {lowerTeeth.map((toothId) => (
          <div
            key={toothId}
            className={getToothClass(toothId)}
            onClick={() => onToothSelect(toothId)}
          >
            <div className="tooth-number">{toothId}</div>
          </div>
        ))}
      </div>
      <div className="arch-label">Arcade Inférieure</div>

      <div className="legend">
        <div className="legend-item">
          <div className="legend-color selected"></div>
          <span>Dent sélectionnée</span>
        </div>
        <div className="legend-item">
          <div className="legend-color configured"></div>
          <span>Dent configurée</span>
        </div>
        <div className="legend-item">
          <div className="legend-color arcade"></div>
          <span>Arcade (Haut/Bas)</span>
        </div>
      </div>
    </div>
  );
};

export default DentalArch;
